import routerConstants from '@/const/routerConstants';
import router from '.';
import store from '@/store/index';

export default [
  // 신청서 전체 메뉴
  {
    name: routerConstants.ApplicationMenu,
    path: '/applicationMenu',
    component: () => import('@/views/application/menu/ApplicationMenuView.vue'),
  },
  // 취소 신청서 메뉴 (근태|보상휴가)
  {
    name: routerConstants.CancelMenu,
    path: '/cancelMenu',
    component: () => import('@/views/application/menu/CancelMenuView.vue'),
  },
  // 근태 코드 선택 (근태명)
  {
    name: routerConstants.GntTypeMenu,
    path: '/gntTypeMenu',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/menu/GntTypeMenuView.vue'),
    props: true,
  },
  // 근태 구분 선택
  {
    name: routerConstants.GntGubunMenu,
    path: '/gntGubunMenu',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/menu/GntGubunMenuView.vue'),
    props: true,
  },
  // 날짜 선택 (시작일자)
  {
    name: routerConstants.StartDate,
    path: '/startDate',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/StartDateView.vue'),
    props: true,
  },
  // 날짜 선택 (종료일자)
  {
    name: routerConstants.EndDate,
    path: '/endDate',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/EndDateView.vue'),
    props: true,
  },
  // 날짜 선택 신규 신청서용(시작일자)
  {
    name: routerConstants.StartDateAppl,
    path: '/startDateAppl',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/StartDateApplView.vue'),
    props: true,
  },
  // 날짜 선택 신규 신청서용(종료일자)
  {
    name: routerConstants.EndDateAppl,
    path: '/endDateAppl',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/EndDateApplView.vue'),
    props: true,
  },
  // 날짜 선택 신규 신청서용(날짜선택)
  {
    name: routerConstants.DateAppl,
    path: '/dateAppl',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/DateApplView.vue'),
  },
  // 시간 선택
  {
    name: routerConstants.SelectTime,
    path: '/selectTime',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/SelectTimeView.vue'),
  },
  // 연장근무신청 시간확인 (근무후신청)
  {
    name: routerConstants.ConfirmOtWorkTime,
    path: '/confirmOtWorkTime',
    meta: { cancelBtn: true },
    component: () =>
      import('@/views/application/form/ConfirmOtWorkTimeView.vue'),
  },
  // 연장근무신청 - 대체휴가 설정
  {
    name: routerConstants.SelectAlterDate,
    path: '/selectAlterDate',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/SelectAlterDateView.vue'),
  },
  // 근무스케줄신청 - 근무스케줄 선택
  {
    name: routerConstants.SelectSchedule,
    path: '/selectSchedule',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/SelectScheduleView.vue'),
  },
  // 결재라인
  {
    name: routerConstants.ApprovalLine,
    path: '/approvalLine',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/ApprovalLineView.vue'),
  },
  // 추가 옵션 (비고, 파일)
  {
    name: routerConstants.ExtraOptions,
    path: '/extraOptions',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/ExtraOptionsView.vue'),
    beforeEnter: (to, from, next) => {
      // console.log(store.getters['ELA/GET_S_YMD']);
      if (store.getters['ELA/GET_APP_MENU'].applCd === '22') {
        if (
          !store.getters['ELA/GET_S_YMD'] ||
          !store.getters['ELA/GET_E_YMD']
        ) {
          alert('일자를 선택해주세요.');
          window.history.go(-2);
          return;
        }
      }
      next();
    },
  },
  // 연차계획작성
  {
    name: routerConstants.AnnualPlanWrite,
    path: '/annualPlanWrite',
    component: () => import('@/views/application/AnnualPlanWriteView.vue'),
  },
  // 연차계획목록
  {
    name: routerConstants.AnnualPlan,
    path: '/annualPlan',
    component: () => import('@/views/application/AnnualPlanView.vue'),
  },
  // 독감예방접종신청
  {
    name: routerConstants.Vaccination,
    path: '/vaccination',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/VaccinationView.vue'),
  },
  // 독감예방접종신청 리스트
  {
    name: routerConstants.VaccinationBoxView,
    path: '/vaccinationBoxView',
    meta: { cancelBtn: true },
    component: () => import('@/views/allDoc/VaccinationBoxView.vue'),
  },
  // 독감예방접종신청 서브 페이지
  {
    name: routerConstants.VaccinationSub,
    path: '/vaccinationSub',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/VaccinationSubView.vue'),
  },
  // 학자금신청
  {
    name: routerConstants.EdusApp,
    path: '/edusApp',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/EdusAppView.vue'),
  },
  {
    name: routerConstants.EdusAppBoxView,
    path: '/edusAppBoxView',
    meta: { cancelBtn: true },
    component: () => import('@/views/allDoc/EdusAppBoxView.vue'),
  },
  // 학자금신청 서브
  {
    name: routerConstants.EdusAppSub,
    path: '/edusAppSub',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/EdusAppSubView.vue'),
    props: true,
  },
  // 휴/복직 신청 첫 페이지
  {
    name: routerConstants.LeaAbsAppStep1,
    path: '/leaAbsAppStep1',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/LeaAbsAppStep1View.vue'),
    props: true,
  },
  // 휴/복직 신청 두번쨰 페이지
  {
    name: routerConstants.LeaAbsAppStep2,
    path: '/leaAbsAppStep2',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/LeaAbsAppStep2View.vue'),
    props: true,
  },
  // 휴/복직 신청 세번쨰 페이지 육아휴직, 가복돌봄휴직
  {
    name: routerConstants.LeaAbsAppStep3,
    path: '/leaAbsAppStep3',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/LeaAbsAppStep3View.vue'),
    props: true,
  },
  // 휴/복직 신청 난임치료휴직, 공상휴직, 사상휴직, 신상휴직 페이지
  {
    name: routerConstants.LeaAbsAppEtcView,
    path: '/leaAbsAppEtcView',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/LeaAbsAppEtcView.vue'),
    props: true,
  },
  // 휴/복직 신청 복직신청 페이지
  {
    name: routerConstants.LeaAbsAppRehView,
    path: '/leaAbsAppRehView',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/LeaAbsAppRehView.vue'),
    props: true,
  },
  // 휴/복직 신청 육아휴직 기신청 내역 페이지
  {
    name: routerConstants.LeaAbsBoxView,
    path: '/leaAbsBoxView',
    meta: { cancelBtn: false },
    component: () => import('@/views/allDoc/LeaAbsBoxView.vue'),
    props: true,
  },
  // 휴/복직 신청 육아휴직(연장) 상세입력 페이지
  {
    name: routerConstants.LeaAbsAppParLeaveView,
    path: '/leaAbsAppParLeaveView',
    meta: { cancelBtn: true },
    component: () =>
      import('@/views/application/form/LeaAbsAppParLeaveView.vue'),
    props: true,
  },
  // 휴/복직 신청 육아휴직(추가) 상세입력 페이지
  {
    name: routerConstants.LeaAbsAppParLeaveAddView,
    path: '/leaAbsAppParLeaveAddView',
    meta: { cancelBtn: true },
    component: () =>
      import('@/views/application/form/LeaAbsAppParLeaveAddView.vue'),
    props: true,
  },
  // 휴일근무사전대체신청
  {
    name: routerConstants.HolReplaceApp,
    path: '/holReplaceApp',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/HolReplaceAppView.vue'),
    props: true,
  },
  // 휴일근무사전대체신청 캘린더
  {
    name: routerConstants.DateHolReplaceAppView,
    path: '/dateHolReplaceAppView',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/DateHolReplaceAppView.vue'),
  },
  // 휴일근무사전대체신청 서브 신청
  {
    name: routerConstants.HolReplaceSubView,
    path: '/holReplaceSubView',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/HolReplaceSubView.vue'),
  },
  // 휴일근무사전대체취소신청 리스트
  {
    name: routerConstants.HolReplaceBoxView,
    path: '/holReplaceBoxView',
    meta: { cancelBtn: true },
    component: () => import('@/views/allDoc/HolReplaceBoxView.vue'),
  },
  // 휴일근무사전대체취소신청 상세
  {
    name: routerConstants.HolReplaceCancelSubView,
    path: '/holReplaceCancelSubView',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/HolReplaceCancelSubView.vue'),
  },
  // 재증명 신청 첫 페이지
  {
    name: routerConstants.ReCertAppStep,
    path: '/reCertAppStep',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/ReCertAppStepView.vue'),
    props: true,
  },
  // 재직신청(한글)
  {
    name: routerConstants.ReCertTenureAppView,
    path: '/reCertTenureAppView',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/ReCertTenureAppView.vue'),
    props: true,
  },
  // 재직신청(영문)
  {
    name: routerConstants.ReCertTenureEngAppView,
    path: '/reCertTenureEngAppView',
    meta: { cancelBtn: true },
    component: () =>
      import('@/views/application/form/ReCertTenureEngAppView.vue'),
    props: true,
  },
  // 원천징수영수증, 원천징수부
  {
    name: routerConstants.ReCertTenureTaxAppView,
    path: '/reCertTenureTaxAppView',
    meta: { cancelBtn: true },
    component: () =>
      import('@/views/application/form/ReCertTenureTaxAppView.vue'),
    props: true,
  },
  // 휴직증명서
  {
    name: routerConstants.ReCertLeaveAppView,
    path: '/reCertLeaveAppView',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/ReCertLeaveAppView.vue'),
    props: true,
  },
  // 갑근세증명원
  {
    name: routerConstants.ReCertGabTaxView,
    path: '/reCertGabTaxView',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/ReCertGabTaxView.vue'),
    props: true,
  },
  // 시차출퇴근제
  {
    name: routerConstants.WorkScheduleTime1,
    path: '/workScheduleTime1',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/WorkScheduleTime1.vue'),
    props: true,
  },
  // 시차출퇴근제 기준일자 캘린더
  {
    name: routerConstants.WorkScheduleTimeView,
    path: '/workScheduleTimeView',
    meta: { cancelBtn: false },
    component: () =>
      import('@/views/application/form/WorkScheduleTimeView.vue'),
    props: true,
  },
  // 시차출퇴근제 두번째 페이지
  {
    name: routerConstants.WorkScheduleTime2,
    path: '/workScheduleTime2',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/WorkScheduleTime2.vue'),
    props: true,
  },
  // 시차출퇴근제 세번째 페이지
  {
    name: routerConstants.WorkScheduleTime3,
    path: '/workScheduleTime3',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/WorkScheduleTime3.vue'),
    props: true,
  },
  // 시차출퇴근제 네번째 페이지
  {
    name: routerConstants.WorkScheduleTime4,
    path: '/workScheduleTime4',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/WorkScheduleTime4.vue'),
    props: true,
  },
  // 설문조사 리스트
  {
    name: routerConstants.SurveyBoxView,
    path: '/surveyBoxView',
    meta: { cancelBtn: true },
    component: () => import('@/views/allDoc/SurveyBoxView.vue'),
  },
  // 설문조사 리스트
  {
    name: routerConstants.SurveyAnswer,
    path: '/surveyAnswer',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/SurveyAnswer.vue'),
  },
  // 휴가신청 상세현황 페이지
  {
    name: routerConstants.VacationMyWorkHoliday,
    path: '/vacationMyWorkHoliday',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/VacationMyWorkHoliday.vue'),
  },
  // 휴가신청 상세현황 페이지
  {
    name: routerConstants.VacationMyWorkHolidayMain,
    path: '/vacationMyWorkHolidayMain',
    meta: { cancelBtn: false },
    component: () => import('@/views/application/form/VacationMyWorkHolidayMain.vue'),
  },
  // 휴가신청 구분 리스트 페이지
  {
    name: routerConstants.VacationGntGubunMenuView,
    path: '/vacationGntGubunMenuView',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/VacationGntGubunMenuView.vue'),
  },
  // 휴가신청 페이지
  {
    name: routerConstants.VacationView,
    path: '/vacationView',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/VacationView.vue'),
  },
  // 근태/휴가 취소신청 상세
  {
    name: routerConstants.VacationCancelView,
    path: '/vacationCancelView',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/VacationCancelView.vue'),
  },
  {
    name: routerConstants.QnaDocument,
    path: '/qnaDocument',
    meta: { cancelBtn: true },
    component: () => import('@/views/home/QnaDocument.vue'),
  },
  {
    name: routerConstants.SurveyStep04,
    path: '/surveyStep04',
    meta: { cancelBtn: true },
    component: () => import('@/views/home/SurveyStep04.vue'),
  },
  // 신청완료 뷰
  {
    name: routerConstants.ApplicationConfirm,
    path: '/applicationConfirm',
    component: () => import('@/views/application/ApplicationConfirmView.vue'),
    beforeEnter: (to, from, next) => {
      // 결재선 화면에서만 접근가능
      if (from.name === routerConstants.ApprovalLine) {
        next();
      } else {
        // 신청완료 후 신청완료뷰어 접근 시 메인으로 이동
        router.push(routerConstants.Main);
        return;
      }
    },
  },
  // 디자인
  {
    name: 'Application',
    path: '/application',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/Application.vue'),
    props: true,
  },
  // 디자인
  {
    name: 'ApplicationRest',
    path: '/applicationRest',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/ApplicationRest.vue'),
    props: true,
  },
  // 디자인
  {
    name: 'ApplicationFile',
    path: '/applicationFile',
    meta: { cancelBtn: true },
    component: () => import('@/views/home/ApplicationFile.vue'),
    props: true,
  },
  {
    name: 'MyWorkHoliday',
    path: '/myWorkHoliday',
    meta: { cancelBtn: true },
    component: () => import('@/views/home/MyWorkHoliday.vue'),
  },
];
